import React, { Suspense } from 'react'
import ErrorBoundary from '@fs/zion-error-boundary'
import { Switch, Route, AuthRoute, NotFound } from '@fs/zion-router'
import Root from '@fs/zion-root'
import { AppLayout } from '@fs/zion-ui'
import Loading from './components/common/Loading'
import RedirectToMessaging from './RedirectToMessaging'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy
const AdminPage = React.lazy(() => import('./components/admin/AdminPage'))
const SupportBlockingPage = React.lazy(() => import('./components/support-blocking/SupportBlockingPage'))
const UnsubscribePage = React.lazy(() => import('./components/unsubscribe/Unsubscribe'))

function App() {
  return (
    <Root analytics>
      <AppLayout fullWidth>
        <ErrorBoundary>
          <Suspense fallback={<Loading />}>
            <Switch>
              <AuthRoute path="/mailbox/admin" component={AdminPage} />
              <AuthRoute path="/support-blocking" component={SupportBlockingPage} />
              <Route path="/unsubscribe" component={UnsubscribePage} />
              <Route path="/mailbox/unsubscribe" component={UnsubscribePage} />
              <Route path="/mailbox" component={RedirectToMessaging} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
        </ErrorBoundary>
      </AppLayout>
    </Root>
  )
}
export default App
